import { useState } from "react";
import { toast } from "react-toastify";
import { useLogout, useCurrentUser } from "utils/hooks";
import { AssignmentLink } from "types";

type Props = {
  assignmentId: string;
  visibleToPatient: boolean;
};

const useFetchAssignmentLink = () => {
  const [loading, setLoading] = useState(false);
  const [existingLink, setExistingLink] = useState<AssignmentLink | null>(null);
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchAssignmentLink = ({ assignmentId, visibleToPatient }: Props) => {
    if (!assignmentId) return toast.error("Error");

    setLoading(true);

    const args = { assignmentId, visibleToPatient };
    try {
      return new Promise(() => {
        fetch(`${process.env.REACT_APP_REST_API_URL}/p/assignment/get-link`, {
          method: "POST",
          credentials: "include",
          body: JSON.stringify({ args }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            organizationId: user?.activeOrganizationId || "NA",
            permissionKey: "read_links",
          },
        })
          .then(async (res) => {
            if (res.status !== 200) {
              const error = await res.json();
              if (
                error?.message.includes("BRKN_6001") ||
                error?.message.includes("GGST_6002") ||
                error?.message.includes("BRKN_6007")
              ) {
                toast.warn("For security purposes please log in again.");
                logOut();
              } else {
                toast.error(`${"Hmm, something went wrong."}`);
                return false;
              }
            }
            return await res.json();
          })
          .then((resData) => {
            if (resData.link) setExistingLink(resData.link);
          })
          .finally(() => setLoading(false));
      });
    } catch (error) {
      console.log(error);
    }
  };

  return { fetchAssignmentLink, existingLink, loading };
};

export default useFetchAssignmentLink;
